/** Worker Trade Organization Dashboard — Welfare Ledger focused. */
import TradeOrgShell from "../../TradeOrgShell";
import WorkerFeaturePanel from "./WorkerFeaturePanel";

const ACCENT = "#8AA6B8";   // steel — workers unions

export default function WorkerDashboard() {
  return (
    <TradeOrgShell variantName="Worker" accent={ACCENT}>
      {({ org, quorum }) => (
        <WorkerFeaturePanel org={org} quorum={quorum} accent={ACCENT} />
      )}
    </TradeOrgShell>
  );
}
